<template>
    <div>
        <vue-headful :title="$t('students-list')" />

        <div class="flex content-center items-center ">
            <div class="items-center ">
                <feather-icon :icon="'ArrowLeftIcon'" @click="$router.go(-1)" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
            </div>
            <div v-if="getClickedLesson" class="flex flex-wrap items-center">
                <h4>
                    {{ getClickedLesson.courses_online_registration.discipline.name }}
                </h4>
                <vs-chip color="primary" class="mx-2">
                    {{ getClickedLesson.courses_online_registration.language.name }}
                </vs-chip>
                <vs-chip color="success">
                    {{ getClickedLesson.load_type  }}
                </vs-chip>
            </div>
        </div>

        <vs-table :data="getStudents" >

            <template slot="thead">

                <vs-th>{{ $t("Student_id") }}</vs-th>
                <vs-th>{{ $t("name") }}</vs-th>
                <vs-th>{{ $t("group") }}</vs-th>
                <vs-th>{{ $t("Major") }}</vs-th>
                <vs-th>{{ $t("program_status") }}</vs-th>
                <vs-th>{{ $t("level") }}</vs-th>
                <vs-th>{{ $t("grade") }}</vs-th>
                <vs-th>{{ $t("co_teacher_of_the_course_if_any") }}</vs-th>
                <vs-th>{{ $t("approved_disapproved") }}</vs-th>
                <vs-th>{{ $t("sent_to_registrar") }}</vs-th>

            </template>

            <template slot-scope="{ data }" >

                <vs-tr :key="index" v-for="(student, index) in data">
                    <vs-td> {{ student.student.student_id }}  </vs-td>
                    <div class="text-primary cursor-pointer" @click="goToProfile(student.student)">
                        {{ student.student.full_name }}
                    </div>
                    <vs-td> {{student.student.study_plan.group}} </vs-td>
                    <vs-td> {{student.student.study_plan.education_program}} </vs-td>
                    <vs-td> {{student.student.study_plan.preparation_level}} ({{ student.student.status }}) </vs-td>
                    <vs-td> {{student.student.study_plan.course}} </vs-td>
                    <vs-td> {{getMark(student.student)}} </vs-td>
                    <vs-td> {{getSecondTeacher(student.student)}} </vs-td>
                    <vs-td> {{getSecondTeacherReview(student.student)}} </vs-td>
                    <vs-td> {{student.student.grade.sent_to_office ? $t('yes') : $t('No')}} </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "GradingTableStudents",
    data() {
        return {
            isSidebarActive: true,
            loading: false,
            emptyMessage: false,
            clickNotClose: true,
            load: false,
            page: 0,
            check: false,
            nextPage: 1,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6,
            },
        }
    },
    created() {
        this.setSidebarWidth()
        this.fetchStudents(this.$route.query)

    },
    computed:{
        ...mapGetters({
            getStudents: 'grading_table/getStudents',
            getClickedLesson: 'grading_table/getClickedLesson'
        }),
    },

    methods:{
        ...mapActions({
            fetchStudents: 'grading_table/fetchStudents'
        }),

        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false;
            } else {
                this.isSidebarActive = this.clickNotClose = true;
            }
        },
        goToProfile(student)  {
            this.$router.push({
                name: "students-list-view",
                query: { uid: student.uid,
                    full_name: student.full_name
                },
            });
        },
        getSecondTeacher(student){
            if (student.grade.second_teacher) return student.grade.second_teacher.full_name
            return ''
        },
        getSecondTeacherReview(student){
            if (student.grade.second_teacher === null ) return ''
            if (student.grade.agreed_second_teacher) return this.$t('Approved')
            return this.$t('Disapproved')
        },

        getMark(student){
            if (student.grade.mark) return student.grade.mark.value_letter
            return this.$t("no_record_in_FinalGrades")
        }
    }
};

</script>

<style scoped>

</style>
